module.exports = __webpack_public_path__ + "img/chest.ba7de587.svg";